import { render, staticRenderFns } from "./getSmsbutton.vue?vue&type=template&id=40a4a483&scoped=true&"
import script from "./getSmsbutton.vue?vue&type=script&lang=js&"
export * from "./getSmsbutton.vue?vue&type=script&lang=js&"
import style0 from "./getSmsbutton.vue?vue&type=style&index=0&id=40a4a483&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4a483",
  null
  
)

export default component.exports